import React, {useEffect, useState} from 'react';
import {DropDownNative, Modal, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import CustomerService from "../services/CustomerService";
import AppGroupService from "../services/AppGroupService";
import {AppGroup} from "../types/AppGroup";
import {useMsal} from "@azure/msal-react";
import HelperMethods from "../../General/services/HelperMethods";

function MoveCustomerToAppGroupModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, handleCustomerMenuModalClose: Function, setLoading: Function, setAlert: Function, reloadCustomerList: Function }) {
    
    const [appGroups, setAppGroups] = useState<AppGroup[]>([]);
    const [loading, setLoading] = useState<boolean>();
    const [selectedAppGroupServerId, setSelectedAppGroupServerId] = useState<number>();
    const [selectedCustomersAppGroupDbVersion, setSelectedCustomersAppGroupDbVersion] = useState<string>();
    const [selectedAppGroupDbVersion, setSelectedAppGroupDbVersion] = useState<string>();

    const { accounts, inProgress } = useMsal();
    
    useEffect(() => {
        setLoading(true)
        AppGroupService.getAppGroups().then((resp) => {
            setAppGroups(resp);
            setLoading(false)
        });


        AppGroupService.getSqlServerVersion(props.selectedCustomer.appgrpServerId).then((resp) => {
            setSelectedCustomersAppGroupDbVersion(resp)
        })
    }, []);
    
    useEffect(() => {
        setLoading(true)
        if (selectedAppGroupServerId) {
            AppGroupService.getSqlServerVersion(selectedAppGroupServerId).then((resp) => {
                setSelectedAppGroupDbVersion(resp)
                setLoading(false)
            })
        }
        else {
            setSelectedAppGroupDbVersion(undefined)
            setLoading(false)
        }
    }, [selectedAppGroupServerId]);
    
    const isMoveValid = () => {
        if (!selectedCustomersAppGroupDbVersion || !selectedAppGroupDbVersion) {
            return false;
        }
        
        return HelperMethods.isSqlServerVersionGreaterOrEqual(selectedAppGroupDbVersion, selectedCustomersAppGroupDbVersion);
    }
    
    const renderAppGroupsDropdown = () => {
        const data = [{ label: 'Select an AppGroup', value: 0 }];
        
        appGroups.forEach((ag: AppGroup) => {
            data.push(
                {label: ag.name, value: ag.serverId}
            )
        });

        return (
            <DropDownNative
                name='template'
                value={selectedAppGroupServerId}
                data={data}
                onChange={(e) => {setSelectedAppGroupServerId(e.target.value)}}
            />
        )
    }
    
    const handleMoveCustomer = () => {
        if (!selectedAppGroupServerId) {
            throw new Error();
        }
        
        const foundAppGrp = appGroups.find(n => n.serverId === selectedAppGroupServerId);
        if (!foundAppGrp) {
            throw new Error();
        }
        
        if (!isMoveValid()) {
            throw new Error();
        }
        
        props.setLoading(true);
        CustomerService.moveCustomer(props.selectedCustomer.clientId, foundAppGrp.name)
            .then(() => {
                props.setLoading(false);
                props.setAlert({type: 'success', message: 'Customer move to app group success'});
                props.handleClose();
                props.handleCustomerMenuModalClose();
                props.reloadCustomerList();
            })
            .catch(() => {
                props.setLoading(false);
                props.setAlert({type: 'error', message: 'An error has occured, please contact HSC Care DevOps'});
                props.handleClose();
                props.handleCustomerMenuModalClose();
            });
    }
    
    const renderModalContent = () => {
        if (loading) {
            return <Spinner />;
        }
        return (
            <>
                {renderAppGroupsDropdown()}
                {selectedAppGroupServerId ?
                    <>
                        <p>
                            Source DB Version - {selectedCustomersAppGroupDbVersion}
                            <br />
                            Target DB Version - {selectedAppGroupDbVersion}
                        </p>
                        { !isMoveValid() ?
                           <div style={{color: 'red'}}>
                               Move is not valid - Target DB must be a newer or same version
                           </div>: undefined
                        }
                    </> : undefined
                }
            </>
        )
    }
    
    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='teal'
            heading={`Move '${props.selectedCustomer.name}' to a new App Group`}
            primaryButtonProps={{disabled: !isMoveValid()}}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onPrimaryButtonClick={() => handleMoveCustomer()}
            onClose={() => props.handleClose()}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default MoveCustomerToAppGroupModal;